import React, {
  Component,
  PropTypes as T,
} from 'react';
import radium, { StyleRoot } from 'radium';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../../actions/Auth.js';

const styles = {
  buttonWrapper: {
    display: 'none',
    width: 44,
    height: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    right: 24,
    top: 24,
    '@media (max-width: 767px)': {
      left: 10,
      top: 'calc(100% - 53px)',
      zIndex: 99,
      position: 'fixed',
    }
  },
  button: {
    fontSize: 24,
    color: '#fff',
    backgroundColor: 'transparent',
    border: 0,
    padding: 0,
    cursor: 'pointer',
    outline: 'none',
    /* tv 1280 : 1920*/
    '@media (width: 1280px)': {
      fontSize: 50,
    },
    /* tv 1080 : 1920*/
    '@media (width: 1080px)': {
      fontSize: 50,
    },
  },
  buttonYellow: {
    color: '#fed312',
  },
  modalWrapper: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: 100,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.29)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    maxWidth: 360,
    width: '100%',
    position: 'relative',
    '@media (max-width: 767px)': {
      padding: '0px 15px',
    },
  },
  closeBtn: {
    cursor: 'pointer',
    position: 'absolute',
    top: -55,
    right: -35,
    fontSize: 30,
    color: '#fff',
    backgroundColor: 'transparent',
    outline: 'none',
    padding: 0,
    border: 0,
    '@media (max-width: 767px)': {
      top: -30,
      right: 0,
    },
  },
  inputGroup: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffe951',
    color: '#004d9f',
    height: 72,
    margin: '18px 0',
    borderRadius: 3,
  },
  inputLabel: {
    fontSize: 30,
    width: 80,
    height: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  input: {
    flex: 1,
    height: 72,
    lineHeight: '72px',
    padding: '0 12px',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    border: 0,
    boxShadow: 'none',
    fontSize: 20,
    fontWeight: 500,
    outline: 'none',
    color: '#004d9f',
  },
  passwordGroup: {
    backgroundColor: '#fed312',
  },
  login: {
    width: '100%',
    backgroundColor: '#004d9f',
    color: '#FFF',
    fontSize: 24,
    height: 72,
    border: 0,
    outline: 'none',
    borderRadius: 3,
    fontWeight: 100,
    textAlign: 'justify',
    textJustify: 'inter-ideograph',
    display: 'block',
    padding: '0 84px',
    lineHeight: '72px',
    cursor: 'pointer',
    WebkitTextAlignLast: 'justify',
    MSTextJustify: 'inter-ideograph',
    MozTextAlignLast: 'justify',
  },
  userIcon: {
    '@media (max-width: 767px)': {
      color: 'blue',
    },
  },
};

class LoginModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if ((!nextProps.isLogined && this.props.isLogined) ||
        (nextProps.isLogined && !this.props.isLogined)) {
      this.setState({
        showModal: false,
      });
    }
  }

  login() {
    const {
      account,
      password,
    } = this.refs;

    const {
      login,
    } = this.props;

    if (account.value && password.value) {
      login(account.value, password.value);
    }
  }

  logout() {
    this.props.logout();
  }

  render() {
    const {
      showModal,
    } = this.state;

    const {
      yellow,
      isLogined,
    } = this.props;

    if (isLogined) {
      return (
        <StyleRoot style={styles.buttonWrapper}>
          <button
            type="button"
            onClick={() => this.setState({ showModal: true })}
            style={[styles.button, yellow && styles.buttonYellow]}>
            <span style={styles.userIcon} className="fa fa-user" />
          </button>
          {showModal ? (
            <div style={styles.modalWrapper}>
              <div style={styles.modal}>
                <button type="button" onClick={() => this.setState({ showModal: false })} style={styles.closeBtn}>
                  <span className="fa fa-times" />
                </button>
                <form>
                  <button
                    type="button"
                    onClick={() => this.logout()}
                    className="text-justify"
                    style={styles.login}>登 出</button>
                </form>
              </div>
            </div>
          ) : null}
        </StyleRoot>
      );
    }
    return (
      <StyleRoot style={styles.buttonWrapper}>
        <button
          type="button"
          onClick={() => this.setState({ showModal: true })}
          style={[styles.button, yellow && styles.buttonYellow]}>
          <span style={styles.userIcon} className="fa fa-user" />
        </button>
        {showModal ? (
          <div style={styles.modalWrapper}>
            <div style={styles.modal}>
              <button type="button" onClick={() => this.setState({ showModal: false })} style={styles.closeBtn}>
                <span className="fa fa-times" />
              </button>
              <form>
                <div style={styles.inputGroup}>
                  <label htmlFor="user-account" style={styles.inputLabel}>
                    <span className="fa fa-user" />
                  </label>
                  <input
                    ref="account"
                    type="text"
                    className="blue-placeholder"
                    id="user-account"
                    style={styles.input}
                    placeholder="請輸入帳號" />
                </div>
                <div style={[styles.inputGroup, styles.passwordGroup]}>
                  <label htmlFor="user-password" style={styles.inputLabel}>
                    <span className="fa fa-lock" />
                  </label>
                  <input
                    ref="password"
                    type="password"
                    className="blue-placeholder"
                    id="user-password"
                    style={styles.input}
                    placeholder="請輸入密碼" />
                </div>
                <button
                  type="button"
                  onClick={() => this.login()}
                  className="text-justify"
                  style={styles.login}>登 入</button>
              </form>
            </div>
          </div>
        ) : null}
      </StyleRoot>
    );
  }
}

LoginModal.defaultProps = {
  yellow: false,
};

LoginModal.propTypes = {
  login: T.func,
  yellow: T.bool,
  isLogined: T.bool,
  logout: T.func,
};

export default connect(
  state => ({
    isLogined: state.Auth.isLogined,
  }),
  dispatch => bindActionCreators(AuthActions, dispatch),
)(radium(LoginModal));



// WEBPACK FOOTER //
// ./containers/Indexes/LoginModal.js